var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon300_local_atm"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1916_1811",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1916_1811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "local_atm",
    d: "M17.1135 25.2365H18.998V23.6403H20.8134C21.1706 23.6403 21.4641 23.5109 21.6938 23.2519C21.9236 22.9929 22.0384 22.6895 22.0384 22.3417V18.332C22.0384 17.9632 21.9236 17.6519 21.6938 17.3981C21.4641 17.1442 21.1706 17.0173 20.8134 17.0173H15.8557V14.2442H22.0384V12.3596H18.998V10.7634H17.1135V12.3596H15.273C14.9231 12.3596 14.6186 12.4891 14.3596 12.7481C14.1006 13.007 13.9712 13.3197 13.9712 13.6862V17.6714C13.9712 18.0379 14.1006 18.3346 14.3596 18.5615C14.6186 18.7884 14.9231 18.9019 15.273 18.9019H20.1539V21.7558H13.9712V23.6403H17.1135V25.2365ZM6.09615 29.2499C5.45145 29.2499 4.89925 29.0201 4.43955 28.5604C3.97985 28.1007 3.75 27.5485 3.75 26.9038V9.09615C3.75 8.45145 3.97985 7.89925 4.43955 7.43955C4.89925 6.97985 5.45145 6.75 6.09615 6.75H29.9038C30.5485 6.75 31.1007 6.97985 31.5604 7.43955C32.0201 7.89925 32.2499 8.45145 32.2499 9.09615V26.9038C32.2499 27.5485 32.0201 28.1007 31.5604 28.5604C31.1007 29.0201 30.5485 29.2499 29.9038 29.2499H6.09615ZM6.09615 27.3654H29.9038C30.0192 27.3654 30.125 27.3173 30.2211 27.2211C30.3173 27.1249 30.3654 27.0192 30.3654 26.9038V9.09615C30.3654 8.98075 30.3173 8.87498 30.2211 8.77883C30.125 8.68265 30.0192 8.63456 29.9038 8.63456H6.09615C5.98075 8.63456 5.87498 8.68265 5.77883 8.77883C5.68265 8.87498 5.63456 8.98075 5.63456 9.09615V26.9038C5.63456 27.0192 5.68265 27.1249 5.77883 27.2211C5.87498 27.3173 5.98075 27.3654 6.09615 27.3654Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.0c4de507656d268306c8f0496fd0f551.svg";
export { ForwardRef as ReactComponent };